export type ErrorRuleDetails = { [key: string]: string|string[] };
export type ErrorRule = string[] | ErrorRuleDetails;

export type ParsedAxiosError = {
  type: 'validation';
  errors: Record<string, ErrorRule>;
};

export type ErrorBag = {
  [key: string]: ErrorRule;
};

export const isErrorRuleDetails = (rule: ErrorRule): rule is ErrorRuleDetails => {
  return !Array.isArray(rule) && typeof rule === 'object' && rule !== null;
};
